import { Capacitor } from '@capacitor/core';

export interface AppStoreRegionInfo {
  countryCode: string | null;
  isUnitedStatesStorefront: boolean;
}

interface AppStoreRegionPlugin {
  getStorefront(): Promise<AppStoreRegionInfo>;
}

const fallbackPlugin: AppStoreRegionPlugin = {
  getStorefront: async () => ({
    countryCode: null,
    isUnitedStatesStorefront: false,
  }),
};

export const AppStoreRegion =
  typeof Capacitor.registerPlugin === 'function'
    ? Capacitor.registerPlugin<AppStoreRegionPlugin>('AppStoreRegion')
    : fallbackPlugin;
